import { useFormStore } from '@/features/form';
import { tryFocus } from '@/utils';
import HandleTabIndex from './HandleTabIndex';

export default function ShiftFocusToTop({ formIsCompleted }) {
	const { shiftFocusToTopRef, actionButtonRef, brandingRef, closeButtonRef } =
		useFormStore();

	return (
		<HandleTabIndex
			ref={shiftFocusToTopRef}
			useTabIndexWhenOpen
			component="div"
			onFocus={e => {
				if (e.relatedTarget === closeButtonRef.current && !formIsCompleted) {
					tryFocus(actionButtonRef.current ?? brandingRef.current);
				} else {
					tryFocus(closeButtonRef.current);
				}
			}}
		/>
	);
}
